import Blizfield81 from '../../../Media/BSD/Blizfield/Blizfield 8.webp'
import Blizfield82 from '../../../Media/BSD/Blizfield/Blizfield 8.webp'





const Blizfield8images =[
Blizfield81,Blizfield82
]

export default Blizfield8images;